module.exports = __webpack_public_path__ + "cbf77255a4b413cfefc61914b8120580.jpg";